import { render, staticRenderFns } from "./FamousChooseRecordItem.vue?vue&type=template&id=7978b382&"
import script from "./FamousChooseRecordItem.vue?vue&type=script&lang=js&"
export * from "./FamousChooseRecordItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports